import * as React from 'react';

type Props = { variant: 'compact' | 'detailed' };

export function ReviewCardSkeleton({ variant }: Props) {
  if (variant === 'compact') {
    return (
      <div
        aria-hidden="true"
        className="flex flex-col bg-white border border-neutral-900/10 px-6 py-8 w-[320px] max-w-[340px] flex-shrink-0 snap-start animate-pulse"
      >
        <div className="flex items-center gap-4">
          <div className="h-10 w-10 rounded-full bg-primary/10" />
          <div className="flex flex-1 flex-col gap-2">
            <div className="h-4 w-24 bg-primary/10" />
            <div className="h-3 w-32 bg-primary/10" />
          </div>
        </div>
        <div className="mt-6 mb-6 flex flex-col gap-2">
          <div className="h-3 w-full bg-primary/10" />
          <div className="h-3 w-[92%] bg-primary/10" />
          <div className="h-3 w-[78%] bg-primary/10" />
        </div>
        <div className="mt-auto pt-6 flex items-center gap-3 border-t border-primary/15">
          <div className="h-3 w-24 bg-primary/10" />
          <div className="h-3 w-8 bg-primary/10" />
        </div>
      </div>
    );
  }

  return (
    <div
      aria-hidden="true"
      className="rounded-[var(--radius-card-sm)] border border-primary/15 bg-white px-5 py-6 shadow-[var(--shadow-card)] animate-pulse sm:px-[34px] sm:py-7"
    >
      <div className="grid grid-cols-[auto_1fr_auto] items-center gap-[18px]">
        <div className="h-12 w-12 rounded-full bg-primary/10" />
        <div className="flex flex-col gap-2">
          <div className="h-4 w-32 bg-primary/10" />
          <div className="h-3 w-40 bg-primary/10" />
        </div>
        <div className="flex flex-col items-end gap-2">
          <div className="h-3 w-20 bg-primary/10" />
          <div className="h-3 w-14 bg-primary/10" />
        </div>
      </div>
      <div className="mt-5 flex items-center gap-3.5">
        <div className="h-4 w-28 bg-primary/10" />
        <div className="h-4 w-8 bg-primary/10" />
      </div>
      <div className="mt-3.5 h-5 w-[70%] bg-primary/10" />
      <div className="mt-3 flex flex-col gap-2">
        <div className="h-3 w-full bg-primary/10" />
        <div className="h-3 w-[95%] bg-primary/10" />
        <div className="h-3 w-[88%] bg-primary/10" />
      </div>
      <div className="mt-5 border-t border-primary/15 pt-[18px]">
        <div className="h-3 w-20 bg-primary/10" />
      </div>
    </div>
  );
}
